import { Grid } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { EventUserState } from "ui/Scripts/source/models/enums";
import { IEventListItem } from "../../../models/event/eventListItem";
import { ISessionState } from "../../../models/session/sessionState";
import { ApproveButton } from "../../framework/Button/ApproveButton";
import { GridRow } from "../../framework/Grid/GridRow";

interface IEventListDetailsHandlersFieldProp {
    sessionState: ISessionState;
    item: IEventListItem;
    onApprove: (item: IEventListItem) => void;
}

export class EventListDetailsHandlersField extends React.Component<IEventListDetailsHandlersFieldProp, {}> {
    render() {
        const props = this.props;
        const item = props.item;
        const sessionState = props.sessionState;
        return (
            <div className="value" title={item.handlers.map(i => i.name + (i.date ? ": " + Base.timeToDateStr(i.date) : "-")).join(",\n")}>
                {item.handlers.map((handler) => {
                    const isUserNotApprovedRow = handler.code === sessionState.code && item.userState === EventUserState.NotApproved;
                    return <GridRow key={handler.code}>
                        <Grid item xs>{handler.name}</Grid>
                        <Grid item xs>
                            {isUserNotApprovedRow
                                ? <ApproveButton
                                    onClick={() => props.onApprove(item)}
                                />
                                : (handler.date ? Base.timeToDateStr(handler.date) : "-")
                            }
                        </Grid>
                    </GridRow>;
                })}
            </div>
        );
    }
}